import { AxiosResponse } from 'axios';
import {
  OpenAmAuthenticateResponse,
  OpenAmAuthenticateResponseOfLoginWithUsernamePassword,
  OpenAmAuthenticateResponseSuccess,
  OpenAMSessionCheckResponse,
} from '../@types/OpenAmInitialData';
import { AuthenticationResource } from './authenticationResource';
import { axiosInstance } from './axiosInstance';

export const keycloakClient: AuthenticationResource = {
  checkSession(): Promise<AxiosResponse<OpenAMSessionCheckResponse>> {
    return Promise.resolve({
      data: { id: '', realm: '', dn: '', successURL: '', fullLoginURL: '' },
      status: 403,
      statusText: 'skipped',
      headers: {},
      config: {},
    } as AxiosResponse<OpenAMSessionCheckResponse>);
  },
  async getInitialData() {
    //@ts-ignore
    const init = window.yuiContext?.init;
    if (typeof init === 'function') {
      await init();
    }

    //@ts-ignore
    const devMode = window.kcDevMode;
    //@ts-ignore
    const loginAction = window.yuiContext?.loginAction;
    //@ts-ignore
    const initialData = window.yuiContext?.initialData;

    console.log('devMode: ', devMode);
    console.log('loginAction: ', loginAction);
    console.log('initialData: ', initialData);

    return Promise.resolve({
      data: initialData,
    } as AxiosResponse<OpenAmAuthenticateResponseOfLoginWithUsernamePassword>);
  },
  postAuthenticatorCode(_authId: string, _authenticatorCode: string): Promise<OpenAmAuthenticateResponse> {
    console.error('postAuthenticatorCode() not implemented yet.');
    throw new Error('postAuthenticatorCode() not implemented yet.');
  },
  async postLogin(
    _authId: string,
    email: string,
    password: string,
    captchaValue: string,
  ): Promise<OpenAmAuthenticateResponse> {
    //@ts-ignore
    const devMode = window.kcDevMode;
    //@ts-ignore
    const loginAction = window.yuiContext?.loginAction;
    const url = new URL(loginAction.replaceAll('&amp;', '&'));
    const path = url.pathname + url.search;

    const formData = new URLSearchParams();
    formData.append('username', email);
    formData.append('password', password);
    formData.append('captchaValue', captchaValue);

    const response: AxiosResponse = await axiosInstance.post(path, formData, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: 'text',
    });

    if (typeof response.data === 'string' && response.data.includes('<FORM')) {
      return Promise.resolve(handleSuccess(response.data, devMode) as OpenAmAuthenticateResponseSuccess);
    } else if (typeof response.data === 'object' && response.data.loginAction && response.data.context) {
      //@ts-ignore
      window.yuiContext.loginAction = response.data.loginAction;

      return Promise.resolve(response.data.context as OpenAmAuthenticateResponse);
    } else if (
      typeof response.data === 'object' &&
      response.data.messageSummary === 'You may close this browser window and go back to your device.'
    ) {
      return Promise.resolve({
        stage: 'deviceLoginSuccess',
        authId: _authId,
      });
    } else if (
      typeof response.data === 'object' &&
      response.data.messageSummary === 'Invalid code, please try again.'
    ) {
      return Promise.resolve({
        stage: 'deviceLoginFailed',
        authId: _authId,
      });
    } else {
      debugger;
      console.error('postLogin() failed');
      throw new Error('postLogin() failed');
    }
  },
  async postMSISDNVerificatorCode(_authId: string, otpCode: string): Promise<OpenAmAuthenticateResponse> {
    //@ts-ignore
    const devMode = window.kcDevMode;
    //@ts-ignore
    const loginAction = window.yuiContext?.loginAction;
    const url = new URL(loginAction.replaceAll('&amp;', '&'));
    const path = url.pathname + url.search;

    const formData = new URLSearchParams();
    formData.append('otpCode', otpCode);

    const response: AxiosResponse = await axiosInstance.post(path, formData, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: 'text',
    });

    if (typeof response.data === 'string' && response.data.includes('<FORM')) {
      return Promise.resolve(handleSuccess(response.data, devMode) as OpenAmAuthenticateResponseSuccess);
    } else if (typeof response.data === 'object' && response.data.loginAction && response.data.context) {
      //@ts-ignore
      window.yuiContext.loginAction = response.data.loginAction;
      return Promise.resolve(response.data.context as OpenAmAuthenticateResponse);
    } else {
      debugger;
      console.error('postMSISDNVerificatorCode() failed');
      throw new Error('postMSISDNVerificatorCode() failed');
    }
  },
  async postPhoneNumber(_authId: string, phoneNumber: string, _stageName: string): Promise<OpenAmAuthenticateResponse> {
    //@ts-ignore
    const devMode = window.kcDevMode;
    //@ts-ignore
    const loginAction = window.yuiContext?.loginAction;
    const url = new URL(loginAction.replaceAll('&amp;', '&'));
    const path = url.pathname + url.search;

    const formData = new URLSearchParams();
    formData.append('phoneNumber', phoneNumber);
    const response: AxiosResponse = await axiosInstance.post(path, formData, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: 'text',
    });

    if (typeof response.data === 'string' && response.data.includes('<FORM')) {
      return Promise.resolve(handleSuccess(response.data, devMode) as OpenAmAuthenticateResponseSuccess);
    } else if (typeof response.data === 'object' && response.data.loginAction && response.data.context) {
      //@ts-ignore
      window.yuiContext.loginAction = response.data.loginAction;

      return Promise.resolve(response.data.context as OpenAmAuthenticateResponse);
    } else {
      debugger;
      console.error('postPhoneNumber() failed.');
      throw new Error('postPhoneNumber() failed');
    }
  },
  async postSMSCode(_authId: string, smsCode: string): Promise<OpenAmAuthenticateResponse> {
    //@ts-ignore
    const devMode = window.kcDevMode;
    //@ts-ignore
    const loginAction = window.yuiContext?.loginAction;
    const url = new URL(loginAction.replaceAll('&amp;', '&'));
    const path = url.pathname + url.search;

    const formData = new URLSearchParams();
    formData.append('smsCode', smsCode);
    const response: AxiosResponse = await axiosInstance.post(path, formData, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: 'text',
    });

    if (typeof response.data === 'string' && response.data.includes('<FORM')) {
      return Promise.resolve(handleSuccess(response.data, devMode) as OpenAmAuthenticateResponseSuccess);
    } else if (typeof response.data === 'object' && response.data.loginAction && response.data.context) {
      //@ts-ignore
      window.yuiContext.loginAction = response.data.loginAction;

      return Promise.resolve(response.data.context as OpenAmAuthenticateResponse);
    } else {
      debugger;
      console.error('postSMSCode() failed.');
      throw new Error('postSMSCode() failed');
    }
  },
  postSMSCodeChange2FA(_authId: string, _smsCode: string): Promise<OpenAmAuthenticateResponse> {
    console.error('postSMSCodeChange2FA() not implemented yet.');
    throw new Error('postSMSCodeChange2FA() not implemented yet.');
  },
  postTestLogin(_authId: string): Promise<OpenAmAuthenticateResponse> {
    console.error('postTestLogin() not implemented yet.');
    throw new Error('postTestLogin() not implemented yet.');
  },
  postYoloOtpCode(_authId: string, _otpCode: string): Promise<OpenAmAuthenticateResponse> {
    console.error('postYoloOtpCode() not implemented yet.');
    throw new Error('postYoloOtpCode() not implemented yet.');
  },
  async reSendMSISDNVerificatorCode(_authId: string): Promise<OpenAmAuthenticateResponse> {
    //@ts-ignore
    const devMode = window.kcDevMode;
    //@ts-ignore
    const loginAction = window.yuiContext?.loginAction;
    const url = new URL(loginAction.replaceAll('&amp;', '&'));
    const path = url.pathname + url.search;

    const formData = new URLSearchParams();
    formData.append('resend', 'true');

    const response: AxiosResponse = await axiosInstance.post(path, formData, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: 'text',
    });

    if (typeof response.data === 'string' && response.data.includes('<FORM')) {
      return Promise.resolve(handleSuccess(response.data, devMode) as OpenAmAuthenticateResponseSuccess);
    } else if (typeof response.data === 'object' && response.data.loginAction && response.data.context) {
      //@ts-ignore
      window.yuiContext.loginAction = response.data.loginAction;
      return Promise.resolve(response.data.context as OpenAmAuthenticateResponse);
    } else {
      debugger;
      console.error('reSendMSISDNVerificatorCode() failed');
      throw new Error('reSendMSISDNVerificatorCode() failed');
    }
  },
  reSendYoloOtpCode(_authId: string): Promise<OpenAmAuthenticateResponse> {
    console.error('reSendYoloOtpCode() not implemented yet.');
    throw new Error('reSendYoloOtpCode() not implemented yet.');
  },
};

const handleSuccess = (data: string, devMode: boolean): OpenAmAuthenticateResponseSuccess | undefined => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(data, 'text/html');
  const form = doc.querySelector('form');

  if (form) {
    let actionUrl = form.action;

    if (devMode && actionUrl) {
      const parsedUrl = new URL(actionUrl);
      actionUrl = parsedUrl.pathname + parsedUrl.search;
    }

    const inputs = form.querySelectorAll('input[type="hidden"]') as NodeListOf<HTMLInputElement>;
    const params = new URLSearchParams();
    let issValue = '';

    inputs.forEach((input: HTMLInputElement) => {
      if (input.name && input.value) {
        params.append(input.name, input.value);
        if (input.name === 'iss') {
          issValue = input.value;
        }
      }
    });

    const getUrl = `${actionUrl}?${params.toString()}`;
    const realm = issValue ? new URL(issValue).pathname.split('/').filter(Boolean).pop() || '' : '';
    const result = { realm: `/${realm}`, successUrl: getUrl };
    console.log('result: ', result);
    return result as OpenAmAuthenticateResponseSuccess;
  }
};
